import axios, {AxiosResponse} from "axios";
import {GetArticleByIdResponse} from "../Article/types";
import {backendUrl} from "../Global/globalValues";

export const fetchDocumentDto = (id: string, setDocumentDto: any) => {
    axios.get<GetArticleByIdResponse>("/document/" + id, {baseURL: backendUrl}).then((res: AxiosResponse) => {
        setDocumentDto(res.data);
    });
}